import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Client, ResponseMetadata } from 'app/model';
import { EndpointsConstants } from 'app/shared/constants/endpoints.constants';

import { HttpClientService } from 'app/core/services/http-client.service';

@Injectable()
export class ClientService {

  constructor(private httpService: HttpClientService) {
  }

  getAllClients(params?): Observable<{ clients: Client[], metadata: ResponseMetadata }> {
    return this.httpService.get<{ clients: Client[], metadata: ResponseMetadata }>(EndpointsConstants.client.all, params)
      .pipe(map(response => {
        return {
          clients: response['data'].clients.map(client => new Client(client)),
          metadata: response['data'].metadata
        };
      }));
  }

  getClient(id: string): Observable<Client> {
    const endpointUrl = EndpointsConstants.client.single.replace('{id}', id);
    return this.httpService.get<Client>(endpointUrl).pipe(map(response => new Client(response['data'])));
  }

  saveClient(clieent: Client): Observable<Client> {
    return this.httpService.post(EndpointsConstants.client.all, clieent).pipe(map(response => new Client(response['data'])));
  }

  updateClient(id: string, editedClient: Client): Observable<Client> {
    const endpointUrl = EndpointsConstants.client.single.replace('{id}', id);
    return this.httpService.put(endpointUrl, editedClient).pipe(map(response => new Client(response['data'])));
  }

  deleteClient(id: string): Observable<{ message: string }> {
    const endpointUrl = EndpointsConstants.client.single.replace('{id}', id);
    return this.httpService.delete<{ message: string }>(endpointUrl);
  }
}
